import Big from 'big.js'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const currencyData = require('./currencies.json')

export default class FormatCurrency {
  static formatCents(amount: number, currency: string, locale: string, minimumFractionDigits = 0, style = 'currency') {
    // using exponent values from ruby-money gem,
    // use puts Money::Currency.table.map
    // { |k, v| [k, {exponent: Money::Currency.new(k).exponent }]}.to_h.to_json
    // to generate currencies.json

    const amountBigDecimal = new Big(amount).div(
      new Big(10 ** currencyData[currency.toLowerCase()].exponent),
    )

    // https://tc39.es/ecma402/#numberformat-objects
    return new Intl.NumberFormat(locale.replace(/_/g, '-'), {
      style,
      currency,
      currencyDisplay: 'code',
      minimumFractionDigits,
    }).format(amountBigDecimal as unknown as number).replace(/\u00A0/g, ' ')
  }
}
